export default "__VITE_ASSET__CAw2mUd0__"